module.exports = __webpack_public_path__ + "media/images/screenshots-288ee17502ed43548e2cbe0dd2c2a6a4.png";